<template>
  <div class="p-4">
    <b-modal ref="surveyModal" id="surveyModal" :title="$t('asset-group-survey.status')" scrollable size="xl" title-class="font-18" v-model="show">
      <survey-question-set-answering />

      <template #modal-footer>
        <div class="w-100 text-right">
          <sweet-button @click="show = false" variant="success" icon="mdi mdi-check" size="sm" buttonClass="ml-2">
            {{ $t("common.ok") }}
          </sweet-button>
        </div>
      </template>
    </b-modal>

    <b-modal ref="adminSurveyModal" id="adminSurveyModal" :title="$t('asset-group-survey.status')" scrollable size="xl" title-class="font-18" v-model="showAdmin">
      <survey-question-set-answering v-if="survey && survey.status" :adminResult="survey.status != 'DONE' ? true : false" />

      <template #modal-footer>
        <div class="w-100 text-right">
          <sweet-button @click="showAdmin = false" variant="success" icon="mdi mdi-check" size="sm" buttonClass="ml-2">
            {{ $t("common.ok") }}
          </sweet-button>
        </div>
      </template>
    </b-modal>
    <div class="mb-4">
      <svg xmlns="http://www.w3.org/2000/svg" width="40" height="38" viewBox="0 0 40 38" fill="none" style="cursor: pointer;" @click="goBack()">
        <path d="M38.75 19.0003H1.25M1.25 19.0003L18.9583 1.29199M1.25 19.0003L18.9583 36.7087" stroke="#FF7C48" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>
    <div class="d-flex justify-content-between" style="margin-bottom: 1.70rem;">
      <div class="d-flex align-items-center" style="gap: 2.34rem;">
        <div>
          <h1 class="title">
            <span v-if="survey">
              {{ survey.name | translate }}
            </span>
          </h1>
        </div>
      </div>
      <div v-if="survey">
        <sweet-button
          v-if="survey.status != 'DONE'"
          @click="completeSurvey()"
          type="submit"
          :disabled="$v.$invalid"
          variant="success"
          icon="mdi mdi-check"
          size="sm"
          buttonClass="mt-2"
        >
          {{ $t("asset-group-survey.complate") }}
        </sweet-button>
      </div>
    </div>

    <div class="table-resonsive">
      <table class="table">
        <thead>
          <tr>
            <th class="text-center" rowspan="1">{{ $t("asset-group-survey.member.text") }}</th>
            <th class="text-center">{{ $t("asset-group-survey.point") }}</th>
            <th class="text-center ">{{ $t("question-set.rating-table-assesment") }}</th>
            <th class="text-center ">{{ $t("asset-group-survey.status") }}</th>
            <th class="text-center "></th>
          </tr>
        </thead>
        <tbody v-if="resultsPagination">
          <tr v-for="result in resultsPagination.docs" v-if="result.participant.title.tr != 'ADMIN'">
            <td>
              <div v-if="result.participant.assignee" class="text-center">
                {{ result.participant.assignee.name }}
              </div>
            </td>

            <td class="text-center">
              <span v-if="result.questionSet && result.questionSet.score">{{ result.questionSet.score }}</span> <span v-else>-</span>
            </td>
            <td class="text-center">
              <span v-if="result.questionSet && result.questionSet.rating">{{ result.questionSet.rating }}</span> <span v-else>-</span>
              <!-- <span v-if="result.questionSet && result.questionSet.rating">{{ result.questionSet.rating }}</span> <span v-else>-</span> -->
            </td>

            <td class="text-center">
              <span
                :class="{
                  'bg-success text-white': result.status === 'DONE',
                  'bg-danger text-white': result.status === 'REJECTED',
                  'bg-main text-white': result.status === 'IN_PROGRESS',
                }"
                class="badge badge-light border border-secondary p-1"
                >{{ displayStatus(result.status) }}</span
              >
            </td>
            <td>
              <div class="text-center">
                <div class="row">
                  <div class="col-md-12">
                    <button @click="showResult(result)" class="btn btn-sm btn-main mr-2 ">
                      {{ $t("asset-group-survey.view") }}
                    </button>
                  </div>
                  <div class="col-md-12">
                    <button v-if="result.status != 'DONE' || survey.status != 'DONE'" @click="reject(result)" class="btn btn-sm btn-primary mr-2 mt-1">
                      {{ $t("asset-group-survey.reject") }}
                    </button>
                  </div>
                  <div class="col-md-12">
                    <button v-if="result.status != 'DONE'" @click="approve(result)" class="btn btn-sm btn-success mt-1">{{ $t("asset-group-survey.approve") }}</button>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <empty v-if="!resultsPagination || resultsPagination.docs.length == 0">
      <h5 class="text-center">
        {{ $t("asset-group-survey.empty") }}
      </h5>
    </empty>

    <div style="height:300px"></div>
  </div>
</template>

<script>
import SurveyQuestionSetAnswering from "./component/survey-question-set-answering.vue";
export default {
  components: { SurveyQuestionSetAnswering },

  data() {
    return {
      show: false,
      showAdmin: false,
      request: {
        options: { page: 1, limit: 200 },
        query: {},
      },
      form: {
        privacy: undefined,
        entirety: undefined,
        accessibility: undefined,
        effectedPeopleCount: undefined,
        socialResults: undefined,
        corporateResults: undefined,
        sectoralEffect: undefined,
        dependentEntities: undefined,
      },
      numberMaxValue: 5,
    };
  },
  async mounted() {
    await this.init();
  },
  watch: {
    showAdmin(v) {
      if (!v) {
        this.init();
      }
    },
  },
  computed: {
    resultsPagination() {
      return this.$store.getters[`organizationSurvey/resultsPagination`];
    },

    survey() {
      return this.$store.getters["organizationSurvey/selectedEntity"];
    },
  },

  validations: {
    // form: {
    //   privacy: { required },
    //   entirety: { required },
    //   accessibility: { required },
    //   effectedPeopleCount: { required },
    //   socialResults: { required },
    //   corporateResults: { required },
    //   sectoralEffect: { required },
    //   dependentEntities: { required },
    // },
  },

  methods: {
    totalPoints(item) {
      return Object.values(item)
        .filter((value) => typeof value === "number")
        .reduce((acc, curr) => Number(acc) + Number(curr), 0);
    },
    async showResult(result, admin) {
      if (admin) {
        this.showAdmin = true;
      } else {
        this.show = true;
      }

      await this.$store.dispatch("organizationQuestionSet/findById", result.questionSet._id);
    },

    goBack() {
      this.$router.push(`/${this.currentProduct.toLowerCase()}/survey/template/${this.survey.template._id}`);
    },
    async init() {
      await this.fetchSurveyResults();
    },
    displayStatus(status) {
      if (status == "DONE") {
        return "Onaylandı";
      } else if (status == "REJECTED") {
        return "Tekrar Gönderildi";
      } else if (status == "IN_PROGRESS") {
        return "Devam Ediyor";
      }
    },
    async reject(result) {
      try {
        const payload = {
          id: result._id,
          status: "REJECTED",
        };
        await this.$store.dispatch("organizationSurveyItem/updateStatus", payload);
        await this.fetchSurveyResults();
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    async approve(result) {
      try {
        const payload = {
          id: result._id,
          status: "DONE",
        };
        await this.$store.dispatch("organizationSurveyItem/updateStatus", payload);
        await this.fetchSurveyResults();
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    async completeSurvey() {
      try {
        if (!this.resultsPagination || !this.resultsPagination.docs) {
          return;
        }
        const results = this.resultsPagination.docs;

        const hasNotApproved = results.length > 0 && results.some((i) => i.status != "DONE");

        if (results.length > 0 && hasNotApproved) {
          this.$toast.warning(this.$t("asset-group-survey.alert.approve-all"));
          return;
        }

        await this.$store.dispatch("organizationSurvey/completeSurvey", this.survey._id);
        this.$toast.success(this.$t("common.success"));
        setTimeout(() => {
          this.goBack();
        }, 1000);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    displayAnswer(questionSet, key) {
      const question = questionSet.questions.find((i) => i.dimension == key);
      if (!question) {
        return "-";
      }
      if (question.answers.length == 0) {
        return "-";
      }

      const selectedOptionId = question.answers[0].optionId;
      const answerIndex = question.options.findIndex((i) => i._id == selectedOptionId);
      const point = question.optionScores.find((i) => i.optionId == selectedOptionId)?.score;

      let selectedOptionWord;
      if (answerIndex == 0) {
        selectedOptionWord = "a";
      } else if (answerIndex == 1) {
        selectedOptionWord = "b";
      } else if (answerIndex == 2) {
        selectedOptionWord = "c";
      } else if (answerIndex == 3) {
        selectedOptionWord = "d";
      } else if (answerIndex == 4) {
        selectedOptionWord = "e";
      } else if (answerIndex == 5) {
        selectedOptionWord = "f";
      } else if (answerIndex == 6) {
        selectedOptionWord = "g";
      }
      return `${selectedOptionWord} (${point}P)`;
    },
    async fetchSurveyResults() {
      try {
        await this.$store.dispatch("organizationSurvey/fetchResults", this.survey ? this.survey._id : this.$route.params.id);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("../entity/organization-entities-view.scss");
</style>
